import { render } from "./About.vue?vue&type=template&id=5b596aed&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=5b596aed&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b596aed"

export default script